import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../api/queryClient';

/**
 * React Query provider.
 *
 * The Devtools floating widget was hidden — it appeared as a stray
 * palm-tree-sun glyph over the bottom-right of the photo grid even in
 * dev. Re-enable here behind an env flag if you actually need it
 * (`import { ReactQueryDevtools } from '@tanstack/react-query-devtools';`
 * and gate on e.g. `import.meta.env.VITE_RQ_DEVTOOLS === '1'`).
 */
export default function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
